module.exports = __webpack_public_path__ + "img/laud.388b1e40.png";